import type {
  ConversationHistoryDateGroupKey,
  ConversationHistorySavedEntry,
} from './types';

export type GroupedConversationsByDate = {
  labelKey: ConversationHistoryDateGroupKey;
  conversations: ConversationHistorySavedEntry[];
};

const DATE_GROUP_ORDER: ConversationHistoryDateGroupKey[] = [
  'today',
  'yesterday',
  'last7Days',
  'last30Days',
  'older',
];

export function groupConversationsByDate(
  conversations: ConversationHistorySavedEntry[],
): GroupedConversationsByDate[] {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const lastWeek = new Date(today);
  lastWeek.setDate(lastWeek.getDate() - 7);
  const lastMonth = new Date(today);
  lastMonth.setDate(lastMonth.getDate() - 30);

  const buckets: Record<
    ConversationHistoryDateGroupKey,
    ConversationHistorySavedEntry[]
  > = {
    today: [],
    yesterday: [],
    last7Days: [],
    last30Days: [],
    older: [],
  };

  conversations.forEach((conversation) => {
    const date = new Date(conversation.updatedAt);
    if (date >= today) {
      buckets.today.push(conversation);
    } else if (date >= yesterday) {
      buckets.yesterday.push(conversation);
    } else if (date >= lastWeek) {
      buckets.last7Days.push(conversation);
    } else if (date >= lastMonth) {
      buckets.last30Days.push(conversation);
    } else {
      buckets.older.push(conversation);
    }
  });

  return DATE_GROUP_ORDER.flatMap((labelKey) => {
    const items = buckets[labelKey];
    if (items.length === 0) {
      return [];
    }
    return [{ labelKey, conversations: items }];
  });
}
